/// <reference types="vite-plugin-svgr/client" />
import styled from "styled-components";
import { FooterProps } from "../editor/FooterEditor";
import MySvg from './boycott_flyer_unframed.svg?react';
import pxFromCm from "../util/pxFromCm";
import { forwardRef } from "react";

const TintedSvg = styled(MySvg)`
  box-sizing: border-box;
  object-fit: contain;
  width: 40px;
  height: 55px;
  margin-bottom: 10px;
  margin-right: 15px;
`;
//   margin: 10px;

interface FooterPreviewProps {
  footerProps?: FooterProps;
  margin: number;
  textColor: string;
}

const FooterPreview = forwardRef<HTMLDivElement, FooterPreviewProps>((props, ref) => {

  const { margin, textColor, footerProps } = props;
  const leftText = footerProps ? footerProps.leftText : "";
  const rightText = footerProps ? footerProps.rightText : "";

  const isRightTextHostname = 
    rightText === "boycott-flyer.eu"
    || rightText === "hardno.eu";

  return (
    <BottomAlignedDiv ref={ref} style={{
      marginBottom: margin,
      marginLeft: margin,
      marginRight: margin,
      width: `calc(100% - 2 * ${margin}px)`,
      borderBottom: `8px solid ${textColor}`,
      color: textColor,
      fontSize: '50px'
    }}>
      {footerProps && footerProps.imageUrl && <FooterImg 
        style={{
          height: pxFromCm(2.35)
        }}
        src={footerProps.imageUrl} />}
      <FooterRow>
        <Left>{leftText}</Left>
        {isRightTextHostname && <TintedSvg style={{ fill: textColor }} />}
        <Right>{rightText}</Right>
      </FooterRow>
    </BottomAlignedDiv>
  )
});

const FooterImg = styled.img`
`;

const FooterRow = styled.div`
  width: 100%;
  display: flex;
  align-items: end;
`;

const BottomAlignedDiv = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: end;
  bottom: 0;
  left: 0;
`;

const Left = styled.div`
  flex-grow: 1;
  width: 0px;
  text-align: left;
`;

const Right = styled.div`
  text-align: right;
`;

export default FooterPreview;